'use strict';

const MainNav = require('./nav/main.js');

function initMainNav (ref) {
  var mainNav = new MainNav(ref);
  mainNav.bindEvents();
}

module.exports = {
  initMainNav: initMainNav
};



//////////////////
// WEBPACK FOOTER
// ./_js/homepage.js
// module id = 26
// module chunks = 7